<template>
  <v-row>
    <v-col cols="12">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <!-- <v-form ref="form" lazy-validation> -->
          <v-card-title>
            <span>Details</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="mt-0 pt-0">
                  <table class="retailer-details">
                    <tr>
                      <td class="w-40">Name:</td>
                      <td>{{ data.firstName }} {{ data.lastName }}</td>
                    </tr>
                    <tr>
                      <td>Mobile Number:</td>
                      <td>{{ data.mobileNumber }}</td>
                    </tr>
                    <tr>
                      <td>City:</td>
                      <td>{{ data.city }}</td>
                    </tr>
                    <tr>
                      <td>Region:</td>
                      <td>{{ data.region }}</td>
                    </tr>
                    <tr>
                      <td>Current Wallet Balance:</td>
                      <td>{{ data.walletBalance }}</td>
                    </tr>
                    <tr>
                      <td>Total Sales Month-to-date:</td>
                      <td>{{ (data.summary) ? data.summary.revenueMonthToDate.toLocaleString() : 0 }}</td>
                    </tr>
                  </table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="pb-5">
            <v-spacer></v-spacer>
            <v-btn :disabled="loadingBtn" @click="closeDialog()">
              Close
            </v-btn>
            <!-- <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn> -->
          </v-card-actions>
          <!-- </v-form> -->
        </v-card>
      </v-dialog>
      <!-- <Snackbar></Snackbar> -->
    </v-col>
  </v-row>
</template>

<script>
// import Snackbar from "../Snackbar.vue";
export default {
  name: "RetailerDetailsDialog",
  components: {
    // Snackbar,
  },
  props: ["dialog", "data"],
  data() {
    return {
      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },
    };
  },
  methods: {
    closeDialog() {
      this.$emit("close", false);
      // this.$refs.form.reset();
    },
  },

  created() {
    // this.getLocation();
  },

  computed: {},
};
</script>

<style scoped>
table.retailer-details {
  width: 100%;
  border-collapse: collapse;
  /* border: 1px solid #e2e2e2; */
  text-align: left;
}

table.retailer-details tr,
td,
th {
  padding: 10px 10px;
  border: 1px solid #e2e2e2;
}

.w-40 {
  width: 40%;
}
</style>
